import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const Image = forwardRef(
  ({
    alt,
    src,
    loading = 'lazy',
    sx,
    width = 100,
    height = 100,
    className,
    imageStyle,
    profile,
  }) => (
    <Box
      sx={{
        height: 'auto', // make square if profile
        // width: profile ? `${width}px` : '100%',
        width: profile ? 'auto' : '100%',
        position: 'relative',
        // aspectRatio: profile ? '150 / 150' : undefined,

        ...sx,
      }}
      className={className}
    >
      <img
        alt={alt}
        src={src}
        loading={loading} // eager
        width={width}
        height={height}
        style={{
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
          ...imageStyle,
        }}
      />
    </Box>
  )
);

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.any,
  className: PropTypes.string,
  sx: PropTypes.object,
  imageStyle: PropTypes.object,
  profile: PropTypes.string,
};

export default Image;
